// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/planner_list.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_planners_v1_resources_planner_list_group } from "./planner_list_group_pb.js";
import { file_studyo_today_planners_v1_resources_planner_list_kind } from "./planner_list_kind_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/planner_list.proto.
 */
export const file_studyo_today_planners_v1_resources_planner_list = /*@__PURE__*/
  fileDesc("CjVzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BsYW5uZXJfbGlzdC5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyKWAQoLUGxhbm5lckxpc3QSQQoEa2luZBgBIAEoDjIzLnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuUGxhbm5lckxpc3RLaW5kEkQKBmdyb3VwcxgCIAMoCzI0LnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuUGxhbm5lckxpc3RHcm91cEIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_planners_v1_resources_planner_list_group, file_studyo_today_planners_v1_resources_planner_list_kind]);

/**
 * Describes the message studyo.today.planners.v1.resources.PlannerList.
 * Use `create(PlannerListSchema)` to create a new message.
 */
export const PlannerListSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_planner_list, 0);

